module.exports = __webpack_public_path__ + "static/media/undraw_tutorial_video_vtd1.edd9f3ce.svg";